export default {
  title: "Tours y experiencias",
  subtitle: "Descubre las mejores experiencias en Baja California Sur",
  resultsCount: "{{count}} resultados encontrados",
  resultsFound: "encontrados",
  noResults: "No se encontraron tours",
  noResultsDesc: "Prueba ajustar los filtros o busca con otros términos",
  clearFilters: "Limpiar filtros",
  loading: "Cargando...",
  loadError: "No se pudieron cargar los tours.",
  toursIn: "en",
  breadcrumb: {
    home: "Inicio",
    tours: "Tours",
  },
  search: {
    placeholder: "Buscar tours...",
    button: "Buscar",
  },
  sort: {
    label: "Ordenar por",
    recommended: "Recomendados",
    priceLow: "Precio: menor a mayor",
    priceHigh: "Precio: mayor a menor",
    rating: "Mejor valorados",
    newest: "Más recientes",
  },
  filters: {
    title: "Filtros",
    price: "Precio",
    minPrice: "Mínimo",
    maxPrice: "Máximo",
    duration: "Duración",
    short: "Menos de 2h",
    medium: "2h - 4h",
    long: "4h - 6h",
    fullDay: "Más de 6h",
    rating: "Valoración",
    excellent: "Excelente (4.5+)",
    veryGood: "Muy bueno (4.0+)",
    good: "Bueno (3.5+)",
    language: "Idioma del tour",
    spanish: "Español",
    english: "Inglés",
    category: "Categoría",
    destination: "Destino",
  },
  card: {
    from: "Desde",
    perPerson: "por persona",
    viewDetails: "Ver detalles",
    hours: "h",
    reviews: "reseñas",
    save: "Guardar",
    bestRated: "Mejor valorado",
  },
  pagination: {
    prev: "Anterior",
    next: "Siguiente",
    page: "Página",
    of: "de",
  },
  destinationPages: {
    aboutTitle: "Sobre el destino",
    highlightsTitle: "Lo más destacado",
    laPaz: {
      tagline: "La capital natural de Baja California Sur",
      desc: "La capital natural de Baja California Sur, donde el mar se encuentra con el desierto en perfecta armonía. Descubre playas vírgenes, avistamiento de ballenas, snorkel con lobos marinos y una gastronomía de clase mundial.",
      fact1: "Capital del estado de Baja California Sur",
      fact2: "Malecón de 5 km con vista al Mar de Cortés",
      fact3: "Isla Espíritu Santo: Patrimonio de la Humanidad",
      fact4: "Clima cálido y seco durante todo el año",
    },
    losCabos: {
      tagline: "Donde el desierto encuentra el mar",
      desc: "El destino de lujo donde el desierto se encuentra con dos mares. Disfruta de resorts de clase mundial, campos de golf, pesca deportiva y paisajes impresionantes entre Cabo San Lucas y San José del Cabo.",
      fact1: "Corredor turístico de 33 km entre los dos Cabos",
      fact2: "Más de 20 campos de golf de clase mundial",
      fact3: "Pesca deportiva reconocida internacionalmente",
      fact4: "El Arco: formación rocosa icónica",
    },
    caboSanLucas: {
      tagline: "El corazón vibrante de Baja",
      desc: "El corazón vibrante de Baja California Sur. Conocida por su vida nocturna, playas de ensueño, deportes acuáticos y el icónico Arco en el Land's End. Un destino que combina aventura y relajación.",
      fact1: "Punta más meridional de la península",
      fact2: "Mar de Cortés y Océano Pacífico en un solo lugar",
      fact3: "Avistamiento de ballenas grises en invierno",
      fact4: "Vida marina única: tiburón ballena, mantarrayas",
    },
  },
};